import axios from '../shared';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.post('auth/token/refresh/');
        const user = response.data

        setAuth(prev => {
            return { ...prev, accessToken: response.data.access, user }
        });
        return response.data.access;
    }
    return refresh;
};

export default useRefreshToken;